export default __webpack_public_path__ + "static/media/icon_car_parked.5a2b44be.svg";